module.exports = __webpack_public_path__ + "img/my-account.85b25776.svg";